<div class="main-container learnspace-theme" *ngIf="program && course">
  <div class="header text-truncate programs-h5">{{ program.title }}</div>
  <hr class="separator">

  <div #list id="list" class="simulations-list" [class.multiple-simulations]="simulationList.length > 1" *ngIf="simulationList">
    <ng-container *ngFor="let simulation of simulationList">
      <div class="programs-body-1" *ngIf="simulation.position === course.position + 1">Next up:</div>
      <div class="simulation" [id]="simulation.id" [class.unreachable]="simulation.position > course.position + 1">
        <div class="poster-image" [style.backgroundImage]="'url(' + (simulation.postermedia?.path || '/assets/wonda/background2_ld.jpg')  + ')'"></div>
        <div class="info-container">
          <div class="title-container">
            <div class="title text-truncate programs-h6">{{ simulation.title }}</div>
            <mat-icon class="done-icon" fontSet="fa" fontIcon="fa-circle-check" *ngIf="simulation.position <= course.position"></mat-icon>
          </div>
          <div class="description programs-subtitle-1">{{ simulation.description }}</div>
        </div>
        <div class="bottom-bar programs-body-1">
          <ng-container *ngIf="simulation.position <= course.position">
            <button mat-stroked-button color="primary" (click)="openAssessment(course.id, simulation.latestSessionWithAssessment)" *ngIf="simulation.latestSessionWithAssessment">
              <mat-icon fontSet="fa" fontIcon="fa-award"></mat-icon>
              REPORT
            </button>
            <button mat-stroked-button color="primary" (click)="openCourse(simulation.id)">
              <mat-icon fontSet="fa" fontIcon="fa-refresh"></mat-icon>
              RESTART
            </button>
          </ng-container>
          <ng-container *ngIf="simulation.position > course.position">
            <button mat-raised-button color="primary" (click)="openCourse(simulation.id)" [disabled]="simulation.position > course.position + 1">
              <mat-icon fontSet="fa" fontIcon="fa-play"></mat-icon>
              LAUNCH
            </button>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
